import React from 'react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';

export const Curriculum = ({ curriculum }) => {
  return (
    <section className="section-padding container-padding section-gradient-purple-light">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16 animate-fade-in-up">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-gray-900">
            Your <span className="gradient-text-green-purple">12-Month Journey</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            A structured, progressive path from foundation to industry leadership
          </p>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Vertical line for desktop */}
          <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-1 bg-gradient-to-b from-green-600 via-purple-600 to-green-600 transform -translate-x-1/2"></div>

          {/* Phases */}
          <div className="space-y-12">
            {curriculum.phases.map((phase, index) => {
              const isEven = index % 2 === 0;
              
              return (
                <div
                  key={index}
                  className={`flex flex-col lg:flex-row gap-8 items-center animate-fade-in-up stagger-${index + 1}`}
                >
                  {/* Left side (for even indices on desktop) */}
                  <div className={`w-full lg:w-5/12 ${isEven ? 'lg:text-right' : 'lg:order-2'}`}>
                    <Card className="card-hover bg-white border-2">
                      <CardContent className="p-6">
                        <Badge className="mb-3 bg-purple-600 text-white">
                          {phase.month}
                        </Badge>
                        <h3 className="text-2xl font-bold mb-3 text-gray-900">
                          {phase.title}
                        </h3>
                        <p className="text-gray-600 mb-4 italic">
                          {phase.focus}
                        </p>
                        <ul className={`space-y-2 ${isEven ? 'lg:text-right' : ''}`}>
                          {phase.modules.map((module, idx) => (
                            <li key={idx} className="text-gray-700 text-sm">
                              • {module}
                            </li>
                          ))}
                        </ul>
                      </CardContent>
                    </Card>
                  </div>

                  {/* Center dot */}
                  <div className="hidden lg:flex w-2/12 justify-center">
                    <div className="w-16 h-16 rounded-full bg-gradient-to-br from-green-600 to-purple-600 flex items-center justify-center text-white font-bold text-xl shadow-lg z-10">
                      {index + 1}
                    </div>
                  </div>

                  {/* Right side placeholder (for even indices on desktop) */}
                  <div className={`hidden lg:block w-5/12 ${isEven ? '' : 'lg:order-1'}`}></div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
